import service from "../../../../../api/services"
import { FetchProductByModelProps } from "../interface"


const fetchProductByModel = async ({ brand_id, product_type_id, search,setProductDataByModel }: FetchProductByModelProps) => {

    try {
        const data = {
            brand_name: brand_id,
            product_type: product_type_id,
            search: search
        }
      const productData = await service.product.fetchProductsByModel(data)
      setProductDataByModel(productData?.data?.data)

    } catch (error) {
        console.error(error)
    }
};

export default fetchProductByModel
